import events from "./events.json";

interface IEvents {
  event: string;
}

const eventsData: IEvents[] = events as unknown as IEvents[];

export { eventsData };
